import React, { useEffect, useState } from "react";

export default function FlowBalls({ pathRef, progress, theme }) {
  const [points, setPoints] = useState([]);

  useEffect(() => {
    if (!pathRef.current) return;
    const path = pathRef.current;
    const length = path.getTotalLength();

    const offsets = [0, -0.06, -0.12];
    const newPoints = offsets.map((o) => {
      const p = Math.max(progress + o, 0);
      return path.getPointAtLength(length * p);
    });

    setPoints(newPoints);
  }, [progress, pathRef]);

  return (
    <>
      {points.map((pt, i) => (
        <div
          key={i}
          className={`wf-ball wf-ball-${i} ${theme}`}
          style={{
            transform: `translate(${pt.x}px, ${pt.y}px)`,
          }}
        />
      ))}
    </>
  );
}
